<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-card-head">
      <h2 class="fo-card-title">
        Contas a receber<small v-if="receivables.count > 0">{{ summary }}</small>
      </h2>
      <router-link :to="route">Abrir na movimentação</router-link>
    </div>

    <div class="fo-rows" v-if="receivables.items.length > 0">
      <div class="fo-line fo-line-receivable" v-for="item in receivables.items" :key="item.id">
        <span class="fo-line-main">
          <strong>{{ item.name || 'Sem pagador' }}</strong>
          <span>{{ [item.document, item.installment].filter(Boolean).join(' · ') }}</span>
        </span>
        <span class="fo-line-date" :class="`is-${due(item).tone}`">
          <strong>{{ shortDate(item.dueDate) }}</strong>
          <span>{{ due(item).text }}</span>
        </span>
        <span class="fo-line-value">{{ money(item.value) }}</span>
      </div>
    </div>
    <div class="fo-empty" v-else>
      <fa-icon :icon="['fal', 'check']"/>
      <strong>Nada a receber no período</strong>
      <span>Nenhum título de paciente ou convênio em aberto com vencimento nessas datas.</span>
    </div>

    <span class="fo-hint fo-card-foot">
      Pacientes e convênios, por vencimento. Recebíveis de cartão ficam de fora.
    </span>
  </section>
</template>

<script>
import {
  dueLabel, money, shortDate, transactionsRoute,
} from './helpers';

export default {
  props: {
    receivables: {
      type: Object,
      required: true,
    },
    period: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    summary() {
      const titles = this.receivables.count === 1 ? '1 título' : `${this.receivables.count} títulos`;
      return `${titles} · ${money(this.receivables.value, this.hidden)}`;
    },
    route() {
      return transactionsRoute({
        type: 'revenue',
        startDate: this.period.startDate,
        endDate: this.period.endDate,
      });
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    shortDate,
    due(item) {
      return dueLabel(item.dueDate, this.date);
    },
  },
};
</script>
